import { Endpoints } from '../../constants/endpoints'
import { Contract, UserDetail } from '../../types/types'
import { getApiData } from '../_GLOBAL/getApiData'

export const getDataContracts = () => getApiData<Contract[]>(Endpoints.dataContract())

export const getDataContractsCustomer = (ico: UserDetail['icoZakaznik']) =>
  getApiData<Contract[]>(Endpoints.dataContractCustomer(ico))
